import React from 'react';
import { useVaultType, VaultType } from '@sc1/common';
import { ScyAdmin } from './ScyAdmin';
import { ScionAdmin } from './ScionAdmin';

export const Admin = (): JSX.Element => {
  const { vaultType } = useVaultType();
  if (vaultType === VaultType.SCYVault) return <ScyAdmin />;
  return <ScionAdmin />;
};
